import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ColorCardComponent } from './components/color-card/color-card.component'
import { FormsModule } from '@angular/forms'
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component'
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component'
import { ApiService } from './services/api.service'
import { HttpClientModule } from '@angular/common/http'
import { ColorPickerModule } from 'angular2-color-picker'
import { CollectionCardComponent } from './components/collection-card/collection-card.component'
import { RouterModule } from '@angular/router'
import { AdminService } from './services/admin/admin.service';
import { CodeblockComponent } from './components/codeblock/codeblock.component'
import {ColorService} from './services/color.service'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule,

    ColorPickerModule
  ],
  declarations: [
    ColorCardComponent,
    LoadingOverlayComponent,
    LoadingSpinnerComponent,
    CollectionCardComponent,
    CodeblockComponent
  ],
  exports: [
    ColorCardComponent,
    LoadingOverlayComponent,
    LoadingSpinnerComponent,
    CollectionCardComponent,
    CodeblockComponent
  ],
  providers: [
    ApiService,
    AdminService,
    ColorService
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/shared/shared.module.ts